module.exports = __webpack_public_path__ + "img/CB3-On-1.b9fd2f6e.gif";